import React from 'react'

const MembershipGroupsCreate = () => {
  return (
    <div>MembershipGroupsCreate</div>
  )
}

export default MembershipGroupsCreate